// extracted by mini-css-extract-plugin
export default {"form":"NovoContrato_form__egvwq","areaBtn":"NovoContrato_areaBtn__TvBi6","btn":"NovoContrato_btn__6toRk","btn2":"NovoContrato_btn2__PaUhB"};